import { Component, EventEmitter, Input, Output, OnDestroy, OnInit, ElementRef, ViewChild, AfterViewInit, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-metro-search-input',
  standalone: false,
  templateUrl: './metro-search-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MetroSearchInputComponent),
      multi: true
    }
  ]
})
export class MetroSearchInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = 'Buscar...';
  @Input() disabled = false;
  @Input() clearable = true;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
 @Input() colorVariant: 'default' | 'brown-alt' = 'default';
  @Output() search = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();

  iconSearch = `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#1C2D36"
  stroke-width="1.75"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
  <path d="M21 21l-6 -6" />
</svg>
`

  iconCleareable = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
`
  iconSizeMap: Record<'sm' | 'md' | 'lg', string> = {
    sm: '14',
    md: '18',
    lg: '22'
  };
  private debounceTimer: any;


  value: string = '';
  onChange = (value: string) => { };
  onTouched = () => { };

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.search.emit(this.value);
    }, 300);
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search.emit(this.value);
    }
  }

  clear() {
    this.value = '';
    this.onChange('');
    this.cleared.emit();
  }
}
